const style = {
  color: "#303030",
  fontSize: 15
};

export function SettingText(props) {
  return (<>
    <span style={ style }>{ props.text }</span>
  </>);
}
